/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'


export default function Table({
    selectedAttendanceRecords,
    setAttendanceRecords,
    handleFetchStudentAttendance,
    type,
    selectedDate,
    disableRemove}) {
    return (
        <>
            <table aria-label="Outside Table" class="w-full table-auto" id="admin-table">
                <thead>
                    <tr class="h-[38px] w-full ">
                        <th class="px-5 py-3 w-[25%]">
                            <span class="flex items-center justify-start text-f2 font-semibold text-[#031624]">{type === "staff" ? "Employee" : "Student"} ID
                            </span>
                        </th>
                        <th class="px-5 py-3 w-[45%]">
                            <span class="flex items-center text-f2 font-semibold text-[#031624] justify-start">{type === "staff" ? "Employee" : "Student"} Name
                            </span>
                        </th>
                        <th class="px-5 py-3 w-[20%]">
                            <span class="flex items-center justify-start text-f2 font-semibold text-[#031624]">{type === "staff" ? "Type" : "Gender"}
                            </span>
                        </th>
                        <th class="px-5 py-3 w-[10%]"></th>
                    </tr>
                    <tr aria-colspan="7" class="h-1"></tr>
                </thead>
                <tbody>
                    {selectedAttendanceRecords?.map((student,index)=>(
                        <Fragment key={index}>
                            <TableBody 
                                student={student} 
                                index={index} 
                                selectedAttendanceRecords={selectedAttendanceRecords} 
                                setAttendanceRecords={setAttendanceRecords}
                                handleFetchStudentAttendance={handleFetchStudentAttendance} 
                                selectedDate={selectedDate}
                                type={type}
                                disableRemove={disableRemove}
                            />
                        </Fragment>
                    ))
                        
                    }
                </tbody>
                {selectedAttendanceRecords?.length === 0 && (
                    <tbody>
                        <tr>
                            <td style={{ 'line-height': '100px' }} colspan="5" className="no-records-message" id='no-matching-result'>
                                {`No records found.`}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </>
    )
}
